module.exports = __webpack_public_path__ + "static/media/iconCalendarControl.7384e70f.svg";